import { Link } from "react-router-dom";

/** Renders a navigable fallback when a static portfolio route is unknown. */
export default function NotFoundPage() {
  return (
    <section className="not-found">
      <p className="eyebrow">404</p>
      <h1>That portfolio page does not exist.</h1>
      <p>
        The project may be private, unpublished, renamed, or not part of the
        public portfolio.
      </p>
      <Link className="button" to="/">
        Return to projects
      </Link>
    </section>
  );
}
